import { orderAgencyOptions, ownerTypeOptions, payTypeOptions, } from '@/constants/deliveryHistory';
import { orderStatusGroupList, searchFieldOptionList, } from '@/constants/listControl';
export const initOrderTotal = () => {
    const orderTotal = Object.keys(orderStatusGroupList).reduce((acc, it) => {
        acc[it] = 0;
        return acc;
    }, {});
    return orderTotal;
};
// const workerTotal = {
//   all: 0,
//   waiting: 0,
//   driving: 0,
//   rest: 0,
// };
export const initState = () => ({
    toggleWorkerList: true,
    contextMenu: {
        isOpen: false,
        event: null,
        orderId: '',
    },
    isStop: false,
    searchWorkerQuery: '',
    isOpenModalAllocate: 0,
    // TODO 목록에서 x
    // isOpenConfigDialog: false,
    // TODO 목록관제에서 필요 없음
    // 설정 다이얼로그
    // mapVisibilitySetting: {
    //   // 공유건 숨김 (리스트, 마커)
    //   isHideShareOrder: false,
    //   isHideShareWorker: false,
    //   // 마커 숨김
    //   isHideStoreMarker: false,
    //   isHideWorkerMarker: false,
    // },
    modalOrderData: {},
    modalWorkerData: {},
    selectedWorker: null,
    // TODO 목록 x
    // selectedStoreId: null,
    // selectedStoreOrderList: {},
    selectedWorkerOrderList: {},
    selectedOrderItemsObj: {},
    selectedOrderFilter: [
        'ALL',
    ],
    selectedWorkerFilter: [
        'ALL',
    ],
    /** 선택된 발주 유형 */
    selectedOrderAgencyType: orderAgencyOptions[0].value,
    /** 선택된 발주 유형 */
    selectedOwnerType: ownerTypeOptions[0].value,
    /** 선택된 결제방법 */
    selectedPayType: payTypeOptions[0].value,
    /** 검색 필드 타입 */
    selectedSearchWordType: searchFieldOptionList[0].value,
    /** 검색어 */
    searchWord: '',
    workerList: {},
    orderList: {},
    // storeList: {},
    relatedWorkerList: {},
    orderTotal: initOrderTotal(),
    cardOrderCount: 0,
    workerTotal: {
        all: 0,
        waiting: 0,
        driving: 0,
        rest: 0,
    },
    // workerTotal,
    // mapHoveredOrderId: '',
    /* eslint-disable object-curly-newline */
    // selectedBySnackbar: {
    // 임시 Interface..!!
    // storeName: ''
    // orderId: '',
    // title: '',
    // workerName: ''
    // },
    // 선택한 스낵바 index
    // selectedItemKey: -1,
    sortBy: [],
    workerSortBy: [],
});
export default initState;
